import {
    SET_IS_LOGIN,
    SET_LOADING_LOGIN,
    SET_LOADED_LOGIN,
    SET_IS_SHOW_TWO_FACTOR,
    SET_VERIFY_EMAIL,
} from '../store/actionTypes';

export const isLogin = (state = false, action) => {
    switch (action.type) {
        case SET_IS_LOGIN:
            return action.payload;
        default:
            return state;
    }
};

export const isLoadedLogin = (state = false, action) => {
    switch (action.type) {
        case SET_LOADING_LOGIN:
            return false;
        case SET_LOADED_LOGIN:
            return true;
        default:
            return state;
    }
};

export const isShowTwoFactor = (state = false, action) => {
    switch (action.type) {
        case SET_IS_SHOW_TWO_FACTOR:
            return action.payload;
        default:
            return state;
    }
};

export const verifyEmail = (state = '', action) => {
    switch (action.type) {
        case SET_VERIFY_EMAIL:
            return action.payload;
        default:
            return state;
    }
};
